import * as React from 'react';
import {
  FileTextIcon,
  MoveRightIcon,
  SquareArrowOutUpRightIcon,
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import type { Trip } from 'contracts/tracking-v2/trips';
import { TRACKING_V2_ROUTES } from 'lib/routes';
import { IndicatorStatusIconAndLabel } from 'pages/tracking-v2/shared-components';
import { CardHeader } from 'components/ui/card';
import { Button } from 'components/ui/button';
import { getInvoiceDestination } from 'pages/tracking-v2/utils/invoice-utils';
import { cn } from 'lib/utils';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  invoice: Trip['invoices'][number];
};

export const InvoiceListItemHeader = ({ className, invoice }: Props) => {
  const destination = getInvoiceDestination(invoice).asCityAndUfText();
  const invoiceNumber = [invoice.infnfeIdeNnf, invoice.infnfeIdeSerie].join('-');

  return (
    <CardHeader className={cn('flex flex-row items-center', className)}>
      <div className={'flex items-center font-GilroySemibold text-slate-600'}>
        <FileTextIcon className={'mr-2 w-6 h-6'} />
        <span className={'text-xl mr-6'}>{invoiceNumber}</span>
        <span className={'text-sm'}>{invoice.supplier.tradeName}</span>
        <MoveRightIcon className={'w-6 h-6 mx-3'} />
        <span className={'text-sm'}>{destination}</span>
      </div>
      <div className={'flex items-center ml-auto gap-4'}>
        <DeliveryStatus invoice={invoice} />
        <InvoiceLinkButton invoiceId={invoice.id} />
      </div>
    </CardHeader>
  );
};

type DeliveryStatusProps = React.HTMLAttributes<HTMLDivElement> & {
  invoice: Trip['invoices'][number];
};

const DeliveryStatus = ({
                          className,
                          invoice,
                          ...props
                        }: DeliveryStatusProps) => {
  const status = invoice.meta?.indicatorStatus;

  if (!status) return null;

  return (
    <div className={cn(className)} {...props}>
      <IndicatorStatusIconAndLabel status={status} />
    </div>
  );
};

type InvoiceLinkButtonProps = {
  invoiceId: string | number;
};

const InvoiceLinkButton = ({ invoiceId }: InvoiceLinkButtonProps) => {
  const navigate = useNavigate();

  return (
    <Button
      variant={'outline'}
      className={'text-slate-600 font-GilroySemibold'}
      onClick={() => {
        navigate(TRACKING_V2_ROUTES.invoiceDetails(invoiceId).url);
      }}
    >
      <SquareArrowOutUpRightIcon className={'w-6 h-6 mr-2'} />
      <span>{'Ver NF'}</span>
    </Button>
  );
};
